'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = exports.stringify = undefined;
exports.combine = combine;

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('linksoft:query-filter');

var defaultOptions = {
    skipDefaults: true,
    boolFlags: true,
    keyValueDelimiter: ':'
};

var stringify = exports.stringify = function stringify(obj, options) {
    // const values = [];
    var opts = (0, _assign2.default)({}, defaultOptions, options);
    var o = (0, _assign2.default)({}, obj);
    (0, _forOwn2.default)(o, function (v, k) {
        if (opts.skipDefaults && !v) {
            delete o[k];
        }
    });
    var jsonString = JSON.stringify(o);
    return jsonString.substring(1, jsonString.length - 1);
    //return JSON.stringify(o).replace(/["\{}]|(:true\b)/g, '');
};

var parse = exports.parse = function parse(text, options) {
    var obj = {};
    var opts = (0, _assign2.default)({}, defaultOptions, options);
    if (!text) text = '';
    //if(opts.keyValueDelimiter !== ':') text = text.replace(opts.keyValueDelimiter, ':');

    //text = text.split(',').map(v => /^[a-z][a-z0-9_]*$/i.test(v) ? v + ':true' : v).join(); // boolean

    //text = text.replace(/(?!false\b)(?!true\b)\b([A-Za-z][A-Za-z0-9_]*)/g, '\"$1\"'); // decorate strings with quotes
    text = '{' + text + '}'; // decorate object with { }
    try {
        obj = JSON.parse(text);
    } catch (error) {
        // ignore
        log(error);
    }
    return obj;
};

function combine(filterText, newFilterValues) {
    var origFilter = parse(filterText);
    log('original filter: %o', origFilter);
    var filter = (0, _assign2.default)({}, origFilter, newFilterValues);
    log('new filter: %o', filter);
    return stringify(filter);
}

exports.default = { stringify: stringify, parse: parse, combine: combine };


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/query-filter.js
// module id = 583
// module chunks = 0 1